import { useContext, useEffect } from 'react';
import { useForm } from 'react-hook-form';
import * as yup from 'yup';

import { UseOpenCloseReturn } from '~/core/hooks/useOpenClose';
import { useRunEquifaxPpsrGrantorSearchRequest } from '~/core/shared/api/plugin';
import { useFormResolver } from '~/core/shared/hooks';
import { useEventHandler } from '~/core/shared/hooks/useEventHandler';
import { handleError, handleSuccess } from '~/core/shared/utils/admin';
import { ApplicationContext } from '../../../../../Layout.component';
import { GrantorSearchFormValues } from '../../types';

export const useGrantorSearchForm = (modalApi: UseOpenCloseReturn) => {
  const { applicationUuid, setLastApplicationUpdate } =
    useContext(ApplicationContext);
  const { runEquifaxPpsrGrantorSearchRequest, isPending } =
    useRunEquifaxPpsrGrantorSearchRequest();

  // TODO: @haxxxton update this to use form blocks
  const resolver = useFormResolver<GrantorSearchFormValues>(
    yup.object({
      grantorId: yup.string().trim().required(),
    }),
  );
  const form = useForm<GrantorSearchFormValues>({
    resolver,
    defaultValues: {
      grantorId: '',
    },
  });

  useEffect(() => {
    if (modalApi.open) {
      form.reset({ grantorId: '' });
    }
  }, [modalApi.open]);

  const startRequest = async (
    values: GrantorSearchFormValues,
  ): Promise<void> => {
    try {
      const response = await runEquifaxPpsrGrantorSearchRequest({
        params: {
          uuid: applicationUuid,
          grantorId: values.grantorId,
        },
      });

      if (response?.data?.errors?.length) {
        handleError(response.data.errors.join(', '));
      } else {
        handleSuccess(
          'PPSR Grantor Search submitted. Certificate will be attached shortly.',
        );
        setLastApplicationUpdate(new Date());
        modalApi.onClose();
      }
    } catch {
      // Error is handled in useRunEquifaxPpsrGrantorSearchRequest
    }
  };

  const onSubmit = useEventHandler((values: GrantorSearchFormValues) => {
    if (values.grantorId) {
      startRequest(values);
    }
  });

  return { form, isLoading: isPending, onSubmit };
};
